import { createBlock } from 'factories/block';

export const createEditableBtn = ({ ...props }) => {
  return createBlock('EditableButton', [], {
    props: {
      type: props.type || 'editableButton',
      label: props.label || 'Edit',
      ...props,
    },
    meta: { subType: 'editableButton' },
  });
};
